@use '../../sass/theme';
:host {
  display: block;
}

.skeleton-loader {
  display: block;
  height: 1rem;
  width: auto;
  position: relative;
  overflow: hidden;
  background-color: var(--jui-skeleton-loader-color-bg);
  border-radius: 3px;
  margin: var(--jds-space-stack-sm);

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
      90deg,
      rgba(var(--jui-skeleton-loader-color-fg-rgb), 0) 0,
      rgba(var(--jui-skeleton-loader-color-fg-rgb), 0.2) 20%,
      rgba(var(--jui-skeleton-loader-color-fg-rgb), 0.5) 60%,
      rgba(var(--jui-skeleton-loader-color-fg-rgb), 0)
    );
    animation: shimmer 1.5s infinite;
    content: '';
  }

  &.circle {
    border-radius: 50%;
  }
  &.primary {
    background-color: var(--jui-primary-color);
    opacity: 0.25;
  }
  &.secondary {
    background-color: var(--jui-secondary-color);
    opacity: 0.25;
  }
  &.info {
    background-color: var(--jui-info-color);
    opacity: 0.25;
  }
  &.success {
    background-color: var(--jui-success-color);
    opacity: 0.25;
  }
  &.warning {
    background-color: var(--jui-warning-color);
    opacity: 0.25;
  }
  &.danger {
    background-color: var(--jui-danger-color);
    opacity: 0.25;
  }
  &.inline {
    display: inline-block;
    margin: var(--jds-space-inline);
    margin-bottom: 0;
  }
  &.glass {
    opacity: 0.25;
  }
  &.no-spacing {
    margin: 0;
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
